import classNames from 'classnames';
import styles from './InquiryNotice.module.scss';
interface ListItem {
  text: string;
  className?: string;
}

interface InquiryNoticeBoxProps {
  title: string;
  className?: string;
  list: ListItem[];
  children?: React.ReactNode;
  bottomSlot?: React.ReactNode;
}

const InquiryNoticeBox = ({
  title,
  className,
  list,
  children,
  bottomSlot,
}: InquiryNoticeBoxProps) => {
  return (
    <div className={classNames(styles.InquiryNoticeWrapper, className)}>
      <div className={styles.InquiryNoticeContainer}>
        <div className={styles.NoticeTitle}>
          <strong>{title}</strong>
        </div>
        <ul className={styles.ListArea}>
          {list.map((item, idx) => (
            <li
              key={idx}
              className={classNames(item.className && styles[item.className])}>
              {item.text}
            </li>
          ))}
        </ul>
        {children && <div>{children}</div>}
      </div>
      {bottomSlot && <div className={styles.BottomArea}>{bottomSlot}</div>}
    </div>
  );
};

export default InquiryNoticeBox;
